import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { loadHtml } from '../components/RenderDT';
import { Helmet } from 'react-helmet';
import Modal from "react-responsive-modal";
import {ShopInfoProps, withShopInfo} from "../contexts/ShopInfoContext";
import {generateBaseUrl} from "../utils";
import Icons from "../components/Icons";

type AboutUsProps = ShopInfoProps & WithTranslation;

class AboutUs extends React.Component<AboutUsProps, any> {
  private _asyncRequest: any;
  private lng: string;
  constructor(props: AboutUsProps) {
    super(props);

    this.lng = props.i18n.language;

    this.state = {
      col1: '',
      col2: '',
      col3: '',
      openVideo: false,
      videoOpenId: 'HFmuWvrwPAI'
    };
  }

  static async getInitialProps() {
    return {};
  }

  async componentDidMount() {
    await this.refreshContent();
  }

  async refreshContent() {
    const col1 = await loadHtml(this.props.i18n.language, 'about_us_col1');
    const col2 = await loadHtml(this.props.i18n.language, 'about_us_col2');
    const col3 = await loadHtml(this.props.i18n.language, 'about_us_col3');
    this.setState({ col1: col1, col2: col2, col3: col3 });

  }

  componentDidUpdate(prevProps: Readonly<any>, _prevState: Readonly<any>, _snapshot?: any): void {
      if(this.lng !== prevProps.i18n.language) {
        this.lng = this.props.i18n.language;
        this.refreshContent();
      }
  }

  onOpenModalVideo = (videoId: any) => {
    if (!this.state.openVideo) { this.setState({openVideo: true,videoOpenId : videoId}); }
  }
  onCloseModalVideo = () => {
    if (this.state.openVideo) { this.setState({openVideo: false}); }
  }

  render() {
    const renderContent = (contenu: any) => {
      const content = this.state[contenu];

      return (
        <div className="intro mt-3 mb-5">
          <div dangerouslySetInnerHTML={{__html: content}}></div>
        </div>
      );
    };

    const baseUrl = generateBaseUrl(this.props.shopInfo.env);
    const canonical = `${baseUrl}/${this.props.i18n.language}/about-us`;
    const canonicalFR = `${baseUrl}/fr/about-us`;
    const canonicalEN = `${baseUrl}/en/about-us`;
    return (
      <>
        <Helmet>
          <title>{this.props.t('about_us_title')}</title>
          <meta name="twitter:card" content="summary"/>
          <meta name="twitter:site" content="@DuckTransfer"/>
          <meta name="description" content={this.props.t('about_us_meta_description')} />
          <meta property="og:description" content={this.props.t('about_us_meta_description')} />
          <meta property="twitter:description" content={this.props.t('about_us_meta_description')} />
          <meta property="og:title" content={this.props.t('about_us_title')} />
          <meta property="twitter:title" content={this.props.t('about_us_title')} />
          <meta property="og:site_name" content="DuckTransfer" />
          <meta property="og:locale" content={this.props.i18n.language + '_' + this.props.i18n.language.toUpperCase()} />
          <meta property="og:type" content="website" />
          <meta property="og:image" content={`${baseUrl}/images/logo-ducktransfer.jpg`} />
          <meta property="twitter:image" content={`${baseUrl}/images/logo-ducktransfer.jpg`} />
          <meta property="og:url" content={canonical} />

          <link rel="canonical" href={canonical} />
          <link rel="alternate" href={canonicalFR} hrefLang="x-default"/>
          <link rel="alternate" href={canonicalFR} hrefLang="fr"/>
          <link rel="alternate" href={canonicalEN} hrefLang="en"/>
        </Helmet>
        <div className={'container-fluid about-us-video'}>
          <div className="about-us-video-container" data-mode="cover" data-scaleoriginx="50" data-scaleoriginy="50"
               data-scale="1">
            <div className={"about-us-video-texte"}>
              <div className={"container-fluid container-fluid-dt"}>
                <div className={'   py-4'} style={{maxWidth: '800px', margin: '0 auto'}}>
                  <div className={'bold font25 pb-4 text-left'}>{this.props.t('baseline')}</div>
                  <div className={'mx-auto font25 text-justify'} style={{maxWidth: '1100px'}}>{this.props.t('our_mission')}</div>
                  <button className={'btn-dt-secondary btn-dt-secondary-red white border border-white shadow-none  d-flex align-items-center text-left  mt-5  px-5 font16'}  onClick={ () => this.onOpenModalVideo(this.state.videoOpenId)}>
                    <Icons icon="just_play" className={" white playVideosIcon pr-2"} size={20}/> <span>{this.props.t('watch_the_movie')}</span>
                  </button>
                </div>
              </div>
            </div>
            <video className="video--element"  poster={"/videos/about-us.jpg"}  preload={"auto"}  autoPlay loop muted playsInline>
              <source
                src="/videos/about-us.webm"
                type="video/webm"/>
                <source
                  src="/videos/about-us.mp4"
                  type="video/mp4"/>
            </video>

          </div>
        </div>
        <div className={'container-fluid container-fluid-dt my-5 px-4'}>
          <Row>
            <Col md={12} className={"mb-3"}>
              <h1>{this.props.t('about_us_h1')}</h1>
            </Col>

            <Col md={4}>
              {renderContent('col1')}
            </Col>
            <Col md={4}>
              {renderContent('col2')}
            </Col>
            <Col md={4}>
              {renderContent('col3')}
            </Col>
          </Row>
        </div>
        {this.state.videoOpenId && this.state.videoOpenId != '' &&
          <Modal open={this.state.openVideo}  onClose={this.onCloseModalVideo} classNames={{closeButton: "zoomVideoInstituCloseBtn" , overlay: "zoomVideoInstituOverlay", modal: "zoomVideo zoomVideoInstitu"}}
                 center>
            <div className={"embed-responsive embed-responsive-16by9"}>
              <iframe className={"embed-responsive-item"}
                      src={`https://www.youtube-nocookie.com/embed/${this.state.videoOpenId}?controls=1&autoplay=1&rel=0&showinfo=0&modestbranding=1&iv_load_policy=3`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen></iframe>
            </div>
          </Modal>
        }
      </>
    );
  }
}

export default withTranslation('aboutUs')(withShopInfo(AboutUs));
